<template>
    <div class="online-dialog-box" v-if="isShow">
        <div class="conten-box">
            <div class="top">
            </div>
            <div class="info-box">
                <div class="main-info">
                    <p>各位用户：</p>
                    <p>为给广大未成年人营造健康的暑期上网环境，按照国家网信办、北京市委网信办统一部署要求，我们将于即日起开展为期2个月的2020“清朗”未成年人暑期网络环境专项整治，针对如下方面重点开展全面深入的清理整治工作：</p>
                    <p>1、重点整治学习网站的网课学习版块的生态问题；</p>
                    <p>2、清理网站平台少儿、动画、动漫等频道的不良动画动漫产品；</p>
                    <p>3、严厉打击直播、短视频网站平台存在的涉未成年人有害信息；</p>
                    <p>4、严格审查即时通讯工具群圈和论坛社区内容，严防危害未成年人身心健康的有害信息蔓延；</p>
                    <p>5、整治诱导未成年人无底线追星、饭圈互撕等价值导向不良信息和行为。</p>
                    <p>希望各位用户理解、配合和支持，谢谢！</p>
                    <p>我们设立的未成年人举报受理电话：‭(010) 5336 8395‬、‭(010) 5336 7059‬，欢迎广大用户提供线索。</p>
                    <p>专项清理整治成果，<span class="click-btn" @click="goLook">点击查看</span></p>
                </div>
                <button class="confirm-btn" @click="know">我知道了</button>
            </div>
        </div>
    </div>
</template>
<script>
import { VUE_APP_PUNISH_URL } from '@/config'
export default {
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    if (sessionStorage.getItem('onlineShow')) {
      this.isShow = false
    } else {
      this.isShow = true
    }
  },
  methods: {
    know () {
      sessionStorage.setItem('onlineShow', '1')
      this.isShow = false
    },
    goLook () {
      window.open(VUE_APP_PUNISH_URL)
    }
  }
}
</script>
<style lang="scss" scoped>
.online-dialog-box{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .conten-box{
        width:428px;
        background:#ffffff;
        border-radius:4px;
        .top{
            width: 100%;
            height: 89px;
            background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/online-bg.png') no-repeat;
            background-size: 100% 100%;
            .title{}
        }
        .info-box{
            padding: 7px 28px 20px;
            .main-info{
                text-align: left;
                font-size:13px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:22px;
                .click-btn{
                  color: rgba(37,135,255,0.8);
                  cursor: pointer;
                  &:hover{
                    color: rgba(37,135,255,1);
                  }
                }
            }
            .confirm-btn{
                cursor: pointer;
                display: block;
                margin: 20px auto 0;
                width:200px;
                height:36px;
                background:rgba(37,135,255,1);
                border-radius:18px;
                font-size:13px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:#ffffff;
                line-height: 36px;
                border: none;
                outline: none;
            }
        }
    }
}
</style>
